





import VueOptions from '@utils/VueOptions'
import AlertBar from '@components/AlertBar'

settings =
  vue:
    name: 'EventAlertBar'
    props: ['event']
    components: { AlertBar }
    methods: 
      organizerAlert: () ->
        return @promptToRecessVerifyAlert() if !@event.recess_verified
        return null
      superAlert: () ->
        return @promptToRecessVerifyAlert() if !@event.recess_verified
        return null
      promptToRecessVerifyAlert: ->
        {
          id: @event.id
          type: 'info'
          message: 'Review this event in order to Recess Verify it.'
          button: null
          dismissable: false
        }

export default VueOptions.vue settings
